import React, { Component } from 'react';
import {Link}from 'react-router-dom';



import imageSupplier01 from './Logos_Lieferanten/exeron.png';
import imageSupplier02 from './Logos_Lieferanten/fehlmann.png';
import imageSupplier05 from './Logos_Lieferanten/ziersch.png';

import imageSupplier06 from './Logos_Lieferanten/ebs.png';
import imageSupplier07 from './Logos_Lieferanten/fanuc.png';


import { Grid, Row, Col, Breadcrumb} from 'react-bootstrap';

class wuf extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="BCMain">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/Suppliers">Übersicht</Breadcrumb.Item>
            <Breadcrumb.Item active>Werkzeug- und Formenbau</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <br/>
        <Grid>
          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Exeron"><img className="supplierImagesOverview" src={imageSupplier01} alt="..." width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Exeron">
              <h3>CNC-Werkzeugmaschinen „made in Germany“ </h3>
              <h4 className="verticalAlign">Die exeron GmbH mit Sitz in Oberndorf am Neckar ist Hersteller qualitativ hochwertiger CNC-Werkzeugmaschinen „made in Germany“. Auf dem Gebiet der Funkenerosions- und Hochgeschwindigkeitsfrästechnik nehmen unsere EDM- und HSC-Maschinen weltweit eine Spitzenstellung ein. </h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Exeron">
              <h4 className="verticalAlign">CNC-Werkzeugmaschinen „made in Germany“ </h4>
            </Link>
            </Col>
          </Row>

          <hr/>
          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Fehlmann"><img className="supplierImagesOverview" src={imageSupplier02} alt="..." width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Fehlmann">
              <h3>Fräsmaschinen von höchster Präzision </h3>
              <h4 className="verticalAlign">Konzept, Konstruktion, Fabrikation, Inbetriebnahme, Service und Schulung – FEHLMANN vereint die ganze Wertschöpfung unter einem Dach. Für Sie als Kunde bedeutet dies: Fräsmaschinen von höchster Präzision, die mit durchdachter Ergonomie, sprichwörtlicher Zuverlässigkeit und kompakter Bauweise überzeugen.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Fehlmann">
              <h4 className="verticalAlign">Fräsmaschinen von höchster Präzision </h4>
            </Link>
            </Col>
          </Row>

            {/* ZIERSCH */}
            <hr/>
          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/ZIERSCH"><img className="supplierImagesOverview" src={imageSupplier05} alt="Logo Ziersch" width="100%" height="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/ZIERSCH">
              <h3 >Hochpräzise Flachschleifmaschinen, Profilschleifmaschinen, Portalschleifmaschinen und Rundtischschleifmaschinen</h3>
              <h4 className="verticalAlign">Die ZIERSCH GmbH hat sich auf die Entwicklung und den Vertrieb von hochpräzisen Flachschleifmaschinen, Profilschleifmaschinen, Portalschleifmaschinen und Rundtischschleifmaschinen spezialisiert.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/ZIERSCH">
              <h4 >Hochpräzise Schleifmaschinen</h4>
            </Link>
            </Col>
          </Row>
          
            {/* EB.S. */}
            <hr/>
          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Ebs"><img className="supplierImagesOverview" src={imageSupplier06} alt="Logo Ebs" width="100%" height="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Ebs">
              <h3 >Strahlkabinen speziell für den Werkzeug- & Formenbau</h3>
              <h4 className="verticalAlign">Genaue und wiederholbare Bearbeitung erodierter Oberflächen sowie die Reinigung von Werkzeugen. </h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Ebs">
              <h4 >Strahlkabinen speziell für den Werkzeug- & Formenbau</h4>
            </Link>
            </Col>
          </Row>
          
          {/* Fanuc */}
          <hr/>
        <Row className="show-grid">
          <Col xs={12}  sm={3}>
              <Link to="/Suppliers/Fanuc"><img className="supplierImagesOverview" src={imageSupplier07} alt="Logo Fanuc" width="100%" height="100%"/></Link>
          </Col>
          <Col xsHidden  sm={9} className="supplierOverviewDesc">
            <Link to="/Suppliers/Fanuc">
            <h3 >Höchste Präzision in der Drahterosion – Für die smarte Fertigung von morgen</h3>
            <h4 className="verticalAlign">Hochpräzise CNC-Drahterodiermaschine, die durch zuverlässige Leistung, intelligente Automatisierung und minimale Wartung höchste Effizienz in der modernen Metallbearbeitung ermöglichen.
            </h4>
          </Link>
          </Col>
          <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
            <Link to="/Suppliers/Fanuc">
            <h4 >Höchste Präzision in der Drahterosion – Für die smarte Fertigung von morgen</h4>
          </Link>
          </Col>
        </Row>
        </Grid>
        <br/>
        <br/>
      </div>
    );
  }
}

export default wuf;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/wuf.js